import { getDefaultConfig, WalletList } from "@rainbow-me/rainbowkit";
import {
  coinbaseWallet,
  coreWallet,
  injectedWallet,
  metaMaskWallet,
  okxWallet,
  rabbyWallet,
  safeWallet,
  trustWallet,
  walletConnectWallet,
} from "@rainbow-me/rainbowkit/wallets";
import { isDevelopment } from "config/env";
import once from "lodash/once";
import { defineChain, fallback, http } from "viem";
import { arbitrum, bsc, avalancheFuji } from "viem/chains";

const bescHyperchain = defineChain({
  id: 2372,
  name: "BESC Hyperchain",
  nativeCurrency: { name: "BESC", symbol: "BESC", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://api.moneyxpro.com/rpc", "https://hyper.beschyperchain.com"] },
  },
  blockExplorers: {
    default: { name: "BESC Explorer", url: "https://explorer.beschyperchain.com" },
  },
});

import binanceWallet from "./connecters/binanceW3W/binanceWallet";

const WALLET_CONNECT_PROJECT_ID = "de24cddbaf2a68f027eae30d9bb5df58";
const APP_NAME = "MONEY";

const popularWalletList: WalletList = [
  {
    // Group name with standard name is localized by rainbow kit
    groupName: "Popular",
    wallets: [
      rabbyWallet,
      metaMaskWallet,
      walletConnectWallet,
      // This wallet will automatically hide itself from the list when the fallback is not necessary or if there is no injected wallet available.
      injectedWallet,
      // The Safe option will only appear in the Safe Wallet browser environment.
      safeWallet,
    ],
  },
];

const othersWalletList: WalletList = [
  {
    groupName: "Others",
    wallets: [binanceWallet, coinbaseWallet, trustWallet, coreWallet, okxWallet],
  },
];

export const getRainbowKitConfig = once(() =>
  getDefaultConfig({
    appName: APP_NAME,
    projectId: WALLET_CONNECT_PROJECT_ID,
    chains: [bescHyperchain, bsc, arbitrum, ...(isDevelopment() ? [avalancheFuji] : [])],
    transports: {
      [bescHyperchain.id]: fallback([
        http("https://api.moneyxpro.com/rpc", { batch: false }),
        http("https://hyper.beschyperchain.com", { batch: false }),
      ]),
      [arbitrum.id]: http(),
      [bsc.id]: http(),
      [avalancheFuji.id]: http(),
    },
    wallets: [...popularWalletList, ...othersWalletList],
  })
);
